module.exports = __webpack_public_path__ + "img/69.c68cad20.png";